/**
 * Created by vedi on 17/08/2017.
 */

export default {
    processors: [
        {
            type: 'road',
        },
    ],
    disappearProcessor: { type: 'disappear' },
    zIndex: -1
};
